import React, { useEffect, useState } from 'react'
import LoadingScreen from '../loadingScreenComp/LoadingScreen'
import AcknowledgementMap from './AcknowledgementMap';
import { APIGetAllAcknowledgments, APIResponseAcknowledgement } from './APIAcknowledgeService';
import AcknowledgmentTable from './AcknowledgmentTable';
import { useNotification } from '../../context/NotificationContext';
import LocationMap from '../map/LocationMap';
import AcknowledgementLayer from './AcknowledgementLayer';

const Acknowledgement = () => {
    // Loading screen
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [acknowledgeData, setAcknowledgeData] = useState<APIResponseAcknowledgement[]>([]);

    const [isNeedReloading, setIsNeedReloading] = useState<boolean>(false)
        
    const { notifications, unreadCount, removeNotification } = useNotification()

    useEffect(() => {
        if (notifications.length > 0) 
        {
            const latest = notifications[0]
            //console.log(`🔔 New: ${latest.title} - ${latest.message}`)
            switch (latest.title)
            {
                case 'NEW_INCIDENT':
                    setIsNeedReloading(prevState => !prevState)
                    removeNotification(latest.id)
                    break
            }
        }
    }, [notifications])

    const getAllAcknowledgement = async () => {
        setIsLoading(true);
        const response = await APIGetAllAcknowledgments();
        setIsLoading(false);
        if(response.status)
        {
            setAcknowledgeData(response.data);
        }
    }

    useEffect(() => {
        getAllAcknowledgement();
    }, [isNeedReloading])

    useEffect(() => {})

    return (
        <div className={`container-wrapper`}>
			<span className={`title`}>Acknowledgement</span>
            <div className='acknowledgement-wrapper'>
                <div className='acknowledgement-body'>
                <LocationMap height="100%" allowIconToggle={false}>
                    <AcknowledgementLayer data={acknowledgeData} />
                </LocationMap>
                </div>
            </div>
            <div className='acknowledgement-wrapper'>
            <span className='title'>Acknowledgement Details</span>
                <div className='acknowledgement-body-details'>
                    <AcknowledgmentTable tableData={acknowledgeData}/>
                </div>
            </div>
        
            {isLoading && <LoadingScreen />}
        </div>
    )
}

export default Acknowledgement